/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as NativeLoadingRouteImport } from './routes/native/loading'
import { Route as AuthenticatedVideoRouteImport } from './routes/_authenticated/video'
import { Route as AuthenticatedPurchaseRouteImport } from './routes/_authenticated/purchase'
import { Route as AuthenticatedNewsRouteImport } from './routes/_authenticated/news'
import { Route as AuthenticatedMessagesRouteImport } from './routes/_authenticated/messages'
import { Route as AuthenticatedIncomingRouteImport } from './routes/_authenticated/incoming'
import { Route as AuthenticatedGalleryRouteImport } from './routes/_authenticated/gallery'
import { Route as AuthenticatedDailyBonusRouteImport } from './routes/_authenticated/daily-bonus'
import { Route as AuthenticatedSettingIndexRouteImport } from './routes/_authenticated/setting/index'
import { Route as AuthenticatedSearchIndexRouteImport } from './routes/_authenticated/search/index'
import { Route as AuthenticatedProfileIndexRouteImport } from './routes/_authenticated/profile/index'
import { Route as AuthenticatedMessagesIndexRouteImport } from './routes/_authenticated/messages/index'
import { Route as AuthenticatedLiveIndexRouteImport } from './routes/_authenticated/live/index'
import { Route as AuthenticatedFleamarketIndexRouteImport } from './routes/_authenticated/fleamarket/index'
import { Route as AuthenticatedDiscoverIndexRouteImport } from './routes/_authenticated/discover/index'
import { Route as AuthenticatedContactIndexRouteImport } from './routes/_authenticated/contact/index'
import { Route as AuthenticatedBoardIndexRouteImport } from './routes/_authenticated/board/index'
import { Route as AuthenticatedSettingLikesRouteImport } from './routes/_authenticated/setting/likes'
import { Route as AuthenticatedSearchResultRouteImport } from './routes/_authenticated/search/result'
import { Route as AuthenticatedProfilePointsHelpRouteImport } from './routes/_authenticated/profile/points-help'
import { Route as AuthenticatedProfileFootprintRouteImport } from './routes/_authenticated/profile/footprint'
import { Route as AuthenticatedProfileEmailRouteImport } from './routes/_authenticated/profile/email'
import { Route as AuthenticatedProfileEditRouteImport } from './routes/_authenticated/profile/edit'
import { Route as AuthenticatedProfileBookmarksRouteImport } from './routes/_authenticated/profile/bookmarks'
import { Route as AuthenticatedProfileBlockedRouteImport } from './routes/_authenticated/profile/blocked'
import { Route as AuthenticatedProfileUserIdRouteImport } from './routes/_authenticated/profile/$userId'
import { Route as AuthenticatedMessagesConversationIdRouteImport } from './routes/_authenticated/messages/$conversationId'
import { Route as AuthenticatedLpReviewRouteImport } from './routes/_authenticated/lp/review'
import { Route as AuthenticatedCallVideoIndexRouteImport } from './routes/_authenticated/call/video/index'
import { Route as AuthenticatedCallLiveIndexRouteImport } from './routes/_authenticated/call/live/index'
import { Route as AuthenticatedCallAudioIndexRouteImport } from './routes/_authenticated/call/audio/index'
import { Route as AuthenticatedProfileLiveBroadcasterUserIdRouteImport } from './routes/_authenticated/profile/live-broadcaster/$userId'
import { Route as AuthenticatedFleamarketTransactionTransactionIdRouteImport } from './routes/_authenticated/fleamarket/transaction/$transactionId'
import { Route as AuthenticatedFleamarketSellerSellerIdRouteImport } from './routes/_authenticated/fleamarket/seller/$sellerId'
import { Route as AuthenticatedFleamarketPurchaseConfirmationItemIdRouteImport } from './routes/_authenticated/fleamarket/purchase-confirmation/$itemId'
import { Route as AuthenticatedFleamarketItemItemIdRouteImport } from './routes/_authenticated/fleamarket/item/$itemId'
import { Route as AuthenticatedCallVideoOutgoingRouteImport } from './routes/_authenticated/call/video/outgoing'
import { Route as AuthenticatedCallAudioOutgoingRouteImport } from './routes/_authenticated/call/audio/outgoing'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const NativeLoadingRoute = NativeLoadingRouteImport.update({
  id: '/native/loading',
  path: '/native/loading',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedVideoRoute = AuthenticatedVideoRouteImport.update({
  id: '/video',
  path: '/video',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPurchaseRoute = AuthenticatedPurchaseRouteImport.update({
  id: '/purchase',
  path: '/purchase',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNewsRoute = AuthenticatedNewsRouteImport.update({
  id: '/news',
  path: '/news',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMessagesRoute = AuthenticatedMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedIncomingRoute = AuthenticatedIncomingRouteImport.update({
  id: '/incoming',
  path: '/incoming',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGalleryRoute = AuthenticatedGalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDailyBonusRoute = AuthenticatedDailyBonusRouteImport.update({
  id: '/daily-bonus',
  path: '/daily-bonus',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingIndexRoute =
  AuthenticatedSettingIndexRouteImport.update({
    id: '/setting/',
    path: '/setting/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSearchIndexRoute =
  AuthenticatedSearchIndexRouteImport.update({
    id: '/search/',
    path: '/search/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileIndexRoute =
  AuthenticatedProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMessagesIndexRoute =
  AuthenticatedMessagesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMessagesRoute,
  } as any)
const AuthenticatedLiveIndexRoute = AuthenticatedLiveIndexRouteImport.update({
  id: '/live/',
  path: '/live/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFleamarketIndexRoute =
  AuthenticatedFleamarketIndexRouteImport.update({
    id: '/fleamarket/',
    path: '/fleamarket/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDiscoverIndexRoute =
  AuthenticatedDiscoverIndexRouteImport.update({
    id: '/discover/',
    path: '/discover/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContactIndexRoute =
  AuthenticatedContactIndexRouteImport.update({
    id: '/contact/',
    path: '/contact/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBoardIndexRoute = AuthenticatedBoardIndexRouteImport.update({
  id: '/board/',
  path: '/board/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingLikesRoute =
  AuthenticatedSettingLikesRouteImport.update({
    id: '/setting/likes',
    path: '/setting/likes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSearchResultRoute =
  AuthenticatedSearchResultRouteImport.update({
    id: '/search/result',
    path: '/search/result',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfilePointsHelpRoute =
  AuthenticatedProfilePointsHelpRouteImport.update({
    id: '/profile/points-help',
    path: '/profile/points-help',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileFootprintRoute =
  AuthenticatedProfileFootprintRouteImport.update({
    id: '/profile/footprint',
    path: '/profile/footprint',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileEmailRoute =
  AuthenticatedProfileEmailRouteImport.update({
    id: '/profile/email',
    path: '/profile/email',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileEditRoute =
  AuthenticatedProfileEditRouteImport.update({
    id: '/profile/edit',
    path: '/profile/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileBookmarksRoute =
  AuthenticatedProfileBookmarksRouteImport.update({
    id: '/profile/bookmarks',
    path: '/profile/bookmarks',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileBlockedRoute =
  AuthenticatedProfileBlockedRouteImport.update({
    id: '/profile/blocked',
    path: '/profile/blocked',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileUserIdRoute =
  AuthenticatedProfileUserIdRouteImport.update({
    id: '/profile/$userId',
    path: '/profile/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMessagesConversationIdRoute =
  AuthenticatedMessagesConversationIdRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => AuthenticatedMessagesRoute,
  } as any)
const AuthenticatedLpReviewRoute = AuthenticatedLpReviewRouteImport.update({
  id: '/lp/review',
  path: '/lp/review',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCallVideoIndexRoute =
  AuthenticatedCallVideoIndexRouteImport.update({
    id: '/call/video/',
    path: '/call/video/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCallLiveIndexRoute =
  AuthenticatedCallLiveIndexRouteImport.update({
    id: '/call/live/',
    path: '/call/live/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCallAudioIndexRoute =
  AuthenticatedCallAudioIndexRouteImport.update({
    id: '/call/audio/',
    path: '/call/audio/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileLiveBroadcasterUserIdRoute =
  AuthenticatedProfileLiveBroadcasterUserIdRouteImport.update({
    id: '/profile/live-broadcaster/$userId',
    path: '/profile/live-broadcaster/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFleamarketTransactionTransactionIdRoute =
  AuthenticatedFleamarketTransactionTransactionIdRouteImport.update({
    id: '/fleamarket/transaction/$transactionId',
    path: '/fleamarket/transaction/$transactionId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFleamarketSellerSellerIdRoute =
  AuthenticatedFleamarketSellerSellerIdRouteImport.update({
    id: '/fleamarket/seller/$sellerId',
    path: '/fleamarket/seller/$sellerId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFleamarketPurchaseConfirmationItemIdRoute =
  AuthenticatedFleamarketPurchaseConfirmationItemIdRouteImport.update({
    id: '/fleamarket/purchase-confirmation/$itemId',
    path: '/fleamarket/purchase-confirmation/$itemId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFleamarketItemItemIdRoute =
  AuthenticatedFleamarketItemItemIdRouteImport.update({
    id: '/fleamarket/item/$itemId',
    path: '/fleamarket/item/$itemId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCallVideoOutgoingRoute =
  AuthenticatedCallVideoOutgoingRouteImport.update({
    id: '/call/video/outgoing',
    path: '/call/video/outgoing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCallAudioOutgoingRoute =
  AuthenticatedCallAudioOutgoingRouteImport.update({
    id: '/call/audio/outgoing',
    path: '/call/audio/outgoing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/signup': typeof SignupRoute
  '/daily-bonus': typeof AuthenticatedDailyBonusRoute
  '/gallery': typeof AuthenticatedGalleryRoute
  '/incoming': typeof AuthenticatedIncomingRoute
  '/messages': typeof AuthenticatedMessagesRouteWithChildren
  '/news': typeof AuthenticatedNewsRoute
  '/purchase': typeof AuthenticatedPurchaseRoute
  '/video': typeof AuthenticatedVideoRoute
  '/native/loading': typeof NativeLoadingRoute
  '/lp/review': typeof AuthenticatedLpReviewRoute
  '/messages/$conversationId': typeof AuthenticatedMessagesConversationIdRoute
  '/profile/$userId': typeof AuthenticatedProfileUserIdRoute
  '/profile/blocked': typeof AuthenticatedProfileBlockedRoute
  '/profile/bookmarks': typeof AuthenticatedProfileBookmarksRoute
  '/profile/edit': typeof AuthenticatedProfileEditRoute
  '/profile/email': typeof AuthenticatedProfileEmailRoute
  '/profile/footprint': typeof AuthenticatedProfileFootprintRoute
  '/profile/points-help': typeof AuthenticatedProfilePointsHelpRoute
  '/search/result': typeof AuthenticatedSearchResultRoute
  '/setting/likes': typeof AuthenticatedSettingLikesRoute
  '/board/': typeof AuthenticatedBoardIndexRoute
  '/contact/': typeof AuthenticatedContactIndexRoute
  '/discover/': typeof AuthenticatedDiscoverIndexRoute
  '/fleamarket/': typeof AuthenticatedFleamarketIndexRoute
  '/live/': typeof AuthenticatedLiveIndexRoute
  '/messages/': typeof AuthenticatedMessagesIndexRoute
  '/profile/': typeof AuthenticatedProfileIndexRoute
  '/search/': typeof AuthenticatedSearchIndexRoute
  '/setting/': typeof AuthenticatedSettingIndexRoute
  '/call/audio/outgoing': typeof AuthenticatedCallAudioOutgoingRoute
  '/call/video/outgoing': typeof AuthenticatedCallVideoOutgoingRoute
  '/fleamarket/item/$itemId': typeof AuthenticatedFleamarketItemItemIdRoute
  '/fleamarket/purchase-confirmation/$itemId': typeof AuthenticatedFleamarketPurchaseConfirmationItemIdRoute
  '/fleamarket/seller/$sellerId': typeof AuthenticatedFleamarketSellerSellerIdRoute
  '/fleamarket/transaction/$transactionId': typeof AuthenticatedFleamarketTransactionTransactionIdRoute
  '/profile/live-broadcaster/$userId': typeof AuthenticatedProfileLiveBroadcasterUserIdRoute
  '/call/audio/': typeof AuthenticatedCallAudioIndexRoute
  '/call/live/': typeof AuthenticatedCallLiveIndexRoute
  '/call/video/': typeof AuthenticatedCallVideoIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/signup': typeof SignupRoute
  '/daily-bonus': typeof AuthenticatedDailyBonusRoute
  '/gallery': typeof AuthenticatedGalleryRoute
  '/incoming': typeof AuthenticatedIncomingRoute
  '/news': typeof AuthenticatedNewsRoute
  '/purchase': typeof AuthenticatedPurchaseRoute
  '/video': typeof AuthenticatedVideoRoute
  '/native/loading': typeof NativeLoadingRoute
  '/lp/review': typeof AuthenticatedLpReviewRoute
  '/messages/$conversationId': typeof AuthenticatedMessagesConversationIdRoute
  '/profile/$userId': typeof AuthenticatedProfileUserIdRoute
  '/profile/blocked': typeof AuthenticatedProfileBlockedRoute
  '/profile/bookmarks': typeof AuthenticatedProfileBookmarksRoute
  '/profile/edit': typeof AuthenticatedProfileEditRoute
  '/profile/email': typeof AuthenticatedProfileEmailRoute
  '/profile/footprint': typeof AuthenticatedProfileFootprintRoute
  '/profile/points-help': typeof AuthenticatedProfilePointsHelpRoute
  '/search/result': typeof AuthenticatedSearchResultRoute
  '/setting/likes': typeof AuthenticatedSettingLikesRoute
  '/board': typeof AuthenticatedBoardIndexRoute
  '/contact': typeof AuthenticatedContactIndexRoute
  '/discover': typeof AuthenticatedDiscoverIndexRoute
  '/fleamarket': typeof AuthenticatedFleamarketIndexRoute
  '/live': typeof AuthenticatedLiveIndexRoute
  '/messages': typeof AuthenticatedMessagesIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
  '/search': typeof AuthenticatedSearchIndexRoute
  '/setting': typeof AuthenticatedSettingIndexRoute
  '/call/audio/outgoing': typeof AuthenticatedCallAudioOutgoingRoute
  '/call/video/outgoing': typeof AuthenticatedCallVideoOutgoingRoute
  '/fleamarket/item/$itemId': typeof AuthenticatedFleamarketItemItemIdRoute
  '/fleamarket/purchase-confirmation/$itemId': typeof AuthenticatedFleamarketPurchaseConfirmationItemIdRoute
  '/fleamarket/seller/$sellerId': typeof AuthenticatedFleamarketSellerSellerIdRoute
  '/fleamarket/transaction/$transactionId': typeof AuthenticatedFleamarketTransactionTransactionIdRoute
  '/profile/live-broadcaster/$userId': typeof AuthenticatedProfileLiveBroadcasterUserIdRoute
  '/call/audio': typeof AuthenticatedCallAudioIndexRoute
  '/call/live': typeof AuthenticatedCallLiveIndexRoute
  '/call/video': typeof AuthenticatedCallVideoIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/signup': typeof SignupRoute
  '/_authenticated/daily-bonus': typeof AuthenticatedDailyBonusRoute
  '/_authenticated/gallery': typeof AuthenticatedGalleryRoute
  '/_authenticated/incoming': typeof AuthenticatedIncomingRoute
  '/_authenticated/messages': typeof AuthenticatedMessagesRouteWithChildren
  '/_authenticated/news': typeof AuthenticatedNewsRoute
  '/_authenticated/purchase': typeof AuthenticatedPurchaseRoute
  '/_authenticated/video': typeof AuthenticatedVideoRoute
  '/native/loading': typeof NativeLoadingRoute
  '/_authenticated/lp/review': typeof AuthenticatedLpReviewRoute
  '/_authenticated/messages/$conversationId': typeof AuthenticatedMessagesConversationIdRoute
  '/_authenticated/profile/$userId': typeof AuthenticatedProfileUserIdRoute
  '/_authenticated/profile/blocked': typeof AuthenticatedProfileBlockedRoute
  '/_authenticated/profile/bookmarks': typeof AuthenticatedProfileBookmarksRoute
  '/_authenticated/profile/edit': typeof AuthenticatedProfileEditRoute
  '/_authenticated/profile/email': typeof AuthenticatedProfileEmailRoute
  '/_authenticated/profile/footprint': typeof AuthenticatedProfileFootprintRoute
  '/_authenticated/profile/points-help': typeof AuthenticatedProfilePointsHelpRoute
  '/_authenticated/search/result': typeof AuthenticatedSearchResultRoute
  '/_authenticated/setting/likes': typeof AuthenticatedSettingLikesRoute
  '/_authenticated/board/': typeof AuthenticatedBoardIndexRoute
  '/_authenticated/contact/': typeof AuthenticatedContactIndexRoute
  '/_authenticated/discover/': typeof AuthenticatedDiscoverIndexRoute
  '/_authenticated/fleamarket/': typeof AuthenticatedFleamarketIndexRoute
  '/_authenticated/live/': typeof AuthenticatedLiveIndexRoute
  '/_authenticated/messages/': typeof AuthenticatedMessagesIndexRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexRoute
  '/_authenticated/search/': typeof AuthenticatedSearchIndexRoute
  '/_authenticated/setting/': typeof AuthenticatedSettingIndexRoute
  '/_authenticated/call/audio/outgoing': typeof AuthenticatedCallAudioOutgoingRoute
  '/_authenticated/call/video/outgoing': typeof AuthenticatedCallVideoOutgoingRoute
  '/_authenticated/fleamarket/item/$itemId': typeof AuthenticatedFleamarketItemItemIdRoute
  '/_authenticated/fleamarket/purchase-confirmation/$itemId': typeof AuthenticatedFleamarketPurchaseConfirmationItemIdRoute
  '/_authenticated/fleamarket/seller/$sellerId': typeof AuthenticatedFleamarketSellerSellerIdRoute
  '/_authenticated/fleamarket/transaction/$transactionId': typeof AuthenticatedFleamarketTransactionTransactionIdRoute
  '/_authenticated/profile/live-broadcaster/$userId': typeof AuthenticatedProfileLiveBroadcasterUserIdRoute
  '/_authenticated/call/audio/': typeof AuthenticatedCallAudioIndexRoute
  '/_authenticated/call/live/': typeof AuthenticatedCallLiveIndexRoute
  '/_authenticated/call/video/': typeof AuthenticatedCallVideoIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/signup'
    | '/daily-bonus'
    | '/gallery'
    | '/incoming'
    | '/messages'
    | '/news'
    | '/purchase'
    | '/video'
    | '/native/loading'
    | '/lp/review'
    | '/messages/$conversationId'
    | '/profile/$userId'
    | '/profile/blocked'
    | '/profile/bookmarks'
    | '/profile/edit'
    | '/profile/email'
    | '/profile/footprint'
    | '/profile/points-help'
    | '/search/result'
    | '/setting/likes'
    | '/board/'
    | '/contact/'
    | '/discover/'
    | '/fleamarket/'
    | '/live/'
    | '/messages/'
    | '/profile/'
    | '/search/'
    | '/setting/'
    | '/call/audio/outgoing'
    | '/call/video/outgoing'
    | '/fleamarket/item/$itemId'
    | '/fleamarket/purchase-confirmation/$itemId'
    | '/fleamarket/seller/$sellerId'
    | '/fleamarket/transaction/$transactionId'
    | '/profile/live-broadcaster/$userId'
    | '/call/audio/'
    | '/call/live/'
    | '/call/video/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/register'
    | '/signup'
    | '/daily-bonus'
    | '/gallery'
    | '/incoming'
    | '/news'
    | '/purchase'
    | '/video'
    | '/native/loading'
    | '/lp/review'
    | '/messages/$conversationId'
    | '/profile/$userId'
    | '/profile/blocked'
    | '/profile/bookmarks'
    | '/profile/edit'
    | '/profile/email'
    | '/profile/footprint'
    | '/profile/points-help'
    | '/search/result'
    | '/setting/likes'
    | '/board'
    | '/contact'
    | '/discover'
    | '/fleamarket'
    | '/live'
    | '/messages'
    | '/profile'
    | '/search'
    | '/setting'
    | '/call/audio/outgoing'
    | '/call/video/outgoing'
    | '/fleamarket/item/$itemId'
    | '/fleamarket/purchase-confirmation/$itemId'
    | '/fleamarket/seller/$sellerId'
    | '/fleamarket/transaction/$transactionId'
    | '/profile/live-broadcaster/$userId'
    | '/call/audio'
    | '/call/live'
    | '/call/video'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/register'
    | '/signup'
    | '/_authenticated/daily-bonus'
    | '/_authenticated/gallery'
    | '/_authenticated/incoming'
    | '/_authenticated/messages'
    | '/_authenticated/news'
    | '/_authenticated/purchase'
    | '/_authenticated/video'
    | '/native/loading'
    | '/_authenticated/lp/review'
    | '/_authenticated/messages/$conversationId'
    | '/_authenticated/profile/$userId'
    | '/_authenticated/profile/blocked'
    | '/_authenticated/profile/bookmarks'
    | '/_authenticated/profile/edit'
    | '/_authenticated/profile/email'
    | '/_authenticated/profile/footprint'
    | '/_authenticated/profile/points-help'
    | '/_authenticated/search/result'
    | '/_authenticated/setting/likes'
    | '/_authenticated/board/'
    | '/_authenticated/contact/'
    | '/_authenticated/discover/'
    | '/_authenticated/fleamarket/'
    | '/_authenticated/live/'
    | '/_authenticated/messages/'
    | '/_authenticated/profile/'
    | '/_authenticated/search/'
    | '/_authenticated/setting/'
    | '/_authenticated/call/audio/outgoing'
    | '/_authenticated/call/video/outgoing'
    | '/_authenticated/fleamarket/item/$itemId'
    | '/_authenticated/fleamarket/purchase-confirmation/$itemId'
    | '/_authenticated/fleamarket/seller/$sellerId'
    | '/_authenticated/fleamarket/transaction/$transactionId'
    | '/_authenticated/profile/live-broadcaster/$userId'
    | '/_authenticated/call/audio/'
    | '/_authenticated/call/live/'
    | '/_authenticated/call/video/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  SignupRoute: typeof SignupRoute
  NativeLoadingRoute: typeof NativeLoadingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/native/loading': {
      id: '/native/loading'
      path: '/native/loading'
      fullPath: '/native/loading'
      preLoaderRoute: typeof NativeLoadingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/video': {
      id: '/_authenticated/video'
      path: '/video'
      fullPath: '/video'
      preLoaderRoute: typeof AuthenticatedVideoRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchase': {
      id: '/_authenticated/purchase'
      path: '/purchase'
      fullPath: '/purchase'
      preLoaderRoute: typeof AuthenticatedPurchaseRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/news': {
      id: '/_authenticated/news'
      path: '/news'
      fullPath: '/news'
      preLoaderRoute: typeof AuthenticatedNewsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/messages': {
      id: '/_authenticated/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AuthenticatedMessagesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/incoming': {
      id: '/_authenticated/incoming'
      path: '/incoming'
      fullPath: '/incoming'
      preLoaderRoute: typeof AuthenticatedIncomingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/gallery': {
      id: '/_authenticated/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof AuthenticatedGalleryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/daily-bonus': {
      id: '/_authenticated/daily-bonus'
      path: '/daily-bonus'
      fullPath: '/daily-bonus'
      preLoaderRoute: typeof AuthenticatedDailyBonusRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/setting/': {
      id: '/_authenticated/setting/'
      path: '/setting'
      fullPath: '/setting/'
      preLoaderRoute: typeof AuthenticatedSettingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/search/': {
      id: '/_authenticated/search/'
      path: '/search'
      fullPath: '/search/'
      preLoaderRoute: typeof AuthenticatedSearchIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedProfileIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/messages/': {
      id: '/_authenticated/messages/'
      path: '/'
      fullPath: '/messages/'
      preLoaderRoute: typeof AuthenticatedMessagesIndexRouteImport
      parentRoute: typeof AuthenticatedMessagesRoute
    }
    '/_authenticated/live/': {
      id: '/_authenticated/live/'
      path: '/live'
      fullPath: '/live/'
      preLoaderRoute: typeof AuthenticatedLiveIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fleamarket/': {
      id: '/_authenticated/fleamarket/'
      path: '/fleamarket'
      fullPath: '/fleamarket/'
      preLoaderRoute: typeof AuthenticatedFleamarketIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/discover/': {
      id: '/_authenticated/discover/'
      path: '/discover'
      fullPath: '/discover/'
      preLoaderRoute: typeof AuthenticatedDiscoverIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contact/': {
      id: '/_authenticated/contact/'
      path: '/contact'
      fullPath: '/contact/'
      preLoaderRoute: typeof AuthenticatedContactIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/board/': {
      id: '/_authenticated/board/'
      path: '/board'
      fullPath: '/board/'
      preLoaderRoute: typeof AuthenticatedBoardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/setting/likes': {
      id: '/_authenticated/setting/likes'
      path: '/setting/likes'
      fullPath: '/setting/likes'
      preLoaderRoute: typeof AuthenticatedSettingLikesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/search/result': {
      id: '/_authenticated/search/result'
      path: '/search/result'
      fullPath: '/search/result'
      preLoaderRoute: typeof AuthenticatedSearchResultRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/points-help': {
      id: '/_authenticated/profile/points-help'
      path: '/profile/points-help'
      fullPath: '/profile/points-help'
      preLoaderRoute: typeof AuthenticatedProfilePointsHelpRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/footprint': {
      id: '/_authenticated/profile/footprint'
      path: '/profile/footprint'
      fullPath: '/profile/footprint'
      preLoaderRoute: typeof AuthenticatedProfileFootprintRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/email': {
      id: '/_authenticated/profile/email'
      path: '/profile/email'
      fullPath: '/profile/email'
      preLoaderRoute: typeof AuthenticatedProfileEmailRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/edit': {
      id: '/_authenticated/profile/edit'
      path: '/profile/edit'
      fullPath: '/profile/edit'
      preLoaderRoute: typeof AuthenticatedProfileEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/bookmarks': {
      id: '/_authenticated/profile/bookmarks'
      path: '/profile/bookmarks'
      fullPath: '/profile/bookmarks'
      preLoaderRoute: typeof AuthenticatedProfileBookmarksRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/blocked': {
      id: '/_authenticated/profile/blocked'
      path: '/profile/blocked'
      fullPath: '/profile/blocked'
      preLoaderRoute: typeof AuthenticatedProfileBlockedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/$userId': {
      id: '/_authenticated/profile/$userId'
      path: '/profile/$userId'
      fullPath: '/profile/$userId'
      preLoaderRoute: typeof AuthenticatedProfileUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/messages/$conversationId': {
      id: '/_authenticated/messages/$conversationId'
      path: '/$conversationId'
      fullPath: '/messages/$conversationId'
      preLoaderRoute: typeof AuthenticatedMessagesConversationIdRouteImport
      parentRoute: typeof AuthenticatedMessagesRoute
    }
    '/_authenticated/lp/review': {
      id: '/_authenticated/lp/review'
      path: '/lp/review'
      fullPath: '/lp/review'
      preLoaderRoute: typeof AuthenticatedLpReviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/call/video/': {
      id: '/_authenticated/call/video/'
      path: '/call/video'
      fullPath: '/call/video/'
      preLoaderRoute: typeof AuthenticatedCallVideoIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/call/live/': {
      id: '/_authenticated/call/live/'
      path: '/call/live'
      fullPath: '/call/live/'
      preLoaderRoute: typeof AuthenticatedCallLiveIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/call/audio/': {
      id: '/_authenticated/call/audio/'
      path: '/call/audio'
      fullPath: '/call/audio/'
      preLoaderRoute: typeof AuthenticatedCallAudioIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/live-broadcaster/$userId': {
      id: '/_authenticated/profile/live-broadcaster/$userId'
      path: '/profile/live-broadcaster/$userId'
      fullPath: '/profile/live-broadcaster/$userId'
      preLoaderRoute: typeof AuthenticatedProfileLiveBroadcasterUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fleamarket/transaction/$transactionId': {
      id: '/_authenticated/fleamarket/transaction/$transactionId'
      path: '/fleamarket/transaction/$transactionId'
      fullPath: '/fleamarket/transaction/$transactionId'
      preLoaderRoute: typeof AuthenticatedFleamarketTransactionTransactionIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fleamarket/seller/$sellerId': {
      id: '/_authenticated/fleamarket/seller/$sellerId'
      path: '/fleamarket/seller/$sellerId'
      fullPath: '/fleamarket/seller/$sellerId'
      preLoaderRoute: typeof AuthenticatedFleamarketSellerSellerIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fleamarket/purchase-confirmation/$itemId': {
      id: '/_authenticated/fleamarket/purchase-confirmation/$itemId'
      path: '/fleamarket/purchase-confirmation/$itemId'
      fullPath: '/fleamarket/purchase-confirmation/$itemId'
      preLoaderRoute: typeof AuthenticatedFleamarketPurchaseConfirmationItemIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/fleamarket/item/$itemId': {
      id: '/_authenticated/fleamarket/item/$itemId'
      path: '/fleamarket/item/$itemId'
      fullPath: '/fleamarket/item/$itemId'
      preLoaderRoute: typeof AuthenticatedFleamarketItemItemIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/call/video/outgoing': {
      id: '/_authenticated/call/video/outgoing'
      path: '/call/video/outgoing'
      fullPath: '/call/video/outgoing'
      preLoaderRoute: typeof AuthenticatedCallVideoOutgoingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/call/audio/outgoing': {
      id: '/_authenticated/call/audio/outgoing'
      path: '/call/audio/outgoing'
      fullPath: '/call/audio/outgoing'
      preLoaderRoute: typeof AuthenticatedCallAudioOutgoingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedMessagesRouteChildren {
  AuthenticatedMessagesConversationIdRoute: typeof AuthenticatedMessagesConversationIdRoute
  AuthenticatedMessagesIndexRoute: typeof AuthenticatedMessagesIndexRoute
}

const AuthenticatedMessagesRouteChildren: AuthenticatedMessagesRouteChildren = {
  AuthenticatedMessagesConversationIdRoute:
    AuthenticatedMessagesConversationIdRoute,
  AuthenticatedMessagesIndexRoute: AuthenticatedMessagesIndexRoute,
}

const AuthenticatedMessagesRouteWithChildren =
  AuthenticatedMessagesRoute._addFileChildren(
    AuthenticatedMessagesRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedDailyBonusRoute: typeof AuthenticatedDailyBonusRoute
  AuthenticatedGalleryRoute: typeof AuthenticatedGalleryRoute
  AuthenticatedIncomingRoute: typeof AuthenticatedIncomingRoute
  AuthenticatedMessagesRoute: typeof AuthenticatedMessagesRouteWithChildren
  AuthenticatedNewsRoute: typeof AuthenticatedNewsRoute
  AuthenticatedPurchaseRoute: typeof AuthenticatedPurchaseRoute
  AuthenticatedVideoRoute: typeof AuthenticatedVideoRoute
  AuthenticatedLpReviewRoute: typeof AuthenticatedLpReviewRoute
  AuthenticatedProfileUserIdRoute: typeof AuthenticatedProfileUserIdRoute
  AuthenticatedProfileBlockedRoute: typeof AuthenticatedProfileBlockedRoute
  AuthenticatedProfileBookmarksRoute: typeof AuthenticatedProfileBookmarksRoute
  AuthenticatedProfileEditRoute: typeof AuthenticatedProfileEditRoute
  AuthenticatedProfileEmailRoute: typeof AuthenticatedProfileEmailRoute
  AuthenticatedProfileFootprintRoute: typeof AuthenticatedProfileFootprintRoute
  AuthenticatedProfilePointsHelpRoute: typeof AuthenticatedProfilePointsHelpRoute
  AuthenticatedSearchResultRoute: typeof AuthenticatedSearchResultRoute
  AuthenticatedSettingLikesRoute: typeof AuthenticatedSettingLikesRoute
  AuthenticatedBoardIndexRoute: typeof AuthenticatedBoardIndexRoute
  AuthenticatedContactIndexRoute: typeof AuthenticatedContactIndexRoute
  AuthenticatedDiscoverIndexRoute: typeof AuthenticatedDiscoverIndexRoute
  AuthenticatedFleamarketIndexRoute: typeof AuthenticatedFleamarketIndexRoute
  AuthenticatedLiveIndexRoute: typeof AuthenticatedLiveIndexRoute
  AuthenticatedProfileIndexRoute: typeof AuthenticatedProfileIndexRoute
  AuthenticatedSearchIndexRoute: typeof AuthenticatedSearchIndexRoute
  AuthenticatedSettingIndexRoute: typeof AuthenticatedSettingIndexRoute
  AuthenticatedCallAudioOutgoingRoute: typeof AuthenticatedCallAudioOutgoingRoute
  AuthenticatedCallVideoOutgoingRoute: typeof AuthenticatedCallVideoOutgoingRoute
  AuthenticatedFleamarketItemItemIdRoute: typeof AuthenticatedFleamarketItemItemIdRoute
  AuthenticatedFleamarketPurchaseConfirmationItemIdRoute: typeof AuthenticatedFleamarketPurchaseConfirmationItemIdRoute
  AuthenticatedFleamarketSellerSellerIdRoute: typeof AuthenticatedFleamarketSellerSellerIdRoute
  AuthenticatedFleamarketTransactionTransactionIdRoute: typeof AuthenticatedFleamarketTransactionTransactionIdRoute
  AuthenticatedProfileLiveBroadcasterUserIdRoute: typeof AuthenticatedProfileLiveBroadcasterUserIdRoute
  AuthenticatedCallAudioIndexRoute: typeof AuthenticatedCallAudioIndexRoute
  AuthenticatedCallLiveIndexRoute: typeof AuthenticatedCallLiveIndexRoute
  AuthenticatedCallVideoIndexRoute: typeof AuthenticatedCallVideoIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDailyBonusRoute: AuthenticatedDailyBonusRoute,
  AuthenticatedGalleryRoute: AuthenticatedGalleryRoute,
  AuthenticatedIncomingRoute: AuthenticatedIncomingRoute,
  AuthenticatedMessagesRoute: AuthenticatedMessagesRouteWithChildren,
  AuthenticatedNewsRoute: AuthenticatedNewsRoute,
  AuthenticatedPurchaseRoute: AuthenticatedPurchaseRoute,
  AuthenticatedVideoRoute: AuthenticatedVideoRoute,
  AuthenticatedLpReviewRoute: AuthenticatedLpReviewRoute,
  AuthenticatedProfileUserIdRoute: AuthenticatedProfileUserIdRoute,
  AuthenticatedProfileBlockedRoute: AuthenticatedProfileBlockedRoute,
  AuthenticatedProfileBookmarksRoute: AuthenticatedProfileBookmarksRoute,
  AuthenticatedProfileEditRoute: AuthenticatedProfileEditRoute,
  AuthenticatedProfileEmailRoute: AuthenticatedProfileEmailRoute,
  AuthenticatedProfileFootprintRoute: AuthenticatedProfileFootprintRoute,
  AuthenticatedProfilePointsHelpRoute: AuthenticatedProfilePointsHelpRoute,
  AuthenticatedSearchResultRoute: AuthenticatedSearchResultRoute,
  AuthenticatedSettingLikesRoute: AuthenticatedSettingLikesRoute,
  AuthenticatedBoardIndexRoute: AuthenticatedBoardIndexRoute,
  AuthenticatedContactIndexRoute: AuthenticatedContactIndexRoute,
  AuthenticatedDiscoverIndexRoute: AuthenticatedDiscoverIndexRoute,
  AuthenticatedFleamarketIndexRoute: AuthenticatedFleamarketIndexRoute,
  AuthenticatedLiveIndexRoute: AuthenticatedLiveIndexRoute,
  AuthenticatedProfileIndexRoute: AuthenticatedProfileIndexRoute,
  AuthenticatedSearchIndexRoute: AuthenticatedSearchIndexRoute,
  AuthenticatedSettingIndexRoute: AuthenticatedSettingIndexRoute,
  AuthenticatedCallAudioOutgoingRoute: AuthenticatedCallAudioOutgoingRoute,
  AuthenticatedCallVideoOutgoingRoute: AuthenticatedCallVideoOutgoingRoute,
  AuthenticatedFleamarketItemItemIdRoute:
    AuthenticatedFleamarketItemItemIdRoute,
  AuthenticatedFleamarketPurchaseConfirmationItemIdRoute:
    AuthenticatedFleamarketPurchaseConfirmationItemIdRoute,
  AuthenticatedFleamarketSellerSellerIdRoute:
    AuthenticatedFleamarketSellerSellerIdRoute,
  AuthenticatedFleamarketTransactionTransactionIdRoute:
    AuthenticatedFleamarketTransactionTransactionIdRoute,
  AuthenticatedProfileLiveBroadcasterUserIdRoute:
    AuthenticatedProfileLiveBroadcasterUserIdRoute,
  AuthenticatedCallAudioIndexRoute: AuthenticatedCallAudioIndexRoute,
  AuthenticatedCallLiveIndexRoute: AuthenticatedCallLiveIndexRoute,
  AuthenticatedCallVideoIndexRoute: AuthenticatedCallVideoIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  SignupRoute: SignupRoute,
  NativeLoadingRoute: NativeLoadingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
